<div class="book-slot-section sec-padding">
    <div class="container">
    <div>
        <h3 class="heading-one text-center">{{headingTitle}}</h3>
        <p class="paragraph-global-text text-center mx-auto mw-650">Thank you for your interest in Amy. Our team will facilitate a demo targeted to your
            needs. Learn more about how our product can work for you and your team!
        </p>
    </div>

    <div class="book-slot-section-in">
         <div class="book-slot-lft">
            <div class="mt-5">
                <div class="">
                    <p-calendar [style]="{transform: 'scale(0.9)', marginTop:'-100px'}" [(ngModel)]="selectedDate"
                        [inline]="true" [minDate]="minDate" [maxDate]="maxDate" [disabledDays]="disabledDays"
                        (onSelect)="onSelectDate($event)">
                    </p-calendar>
                </div>
                <div class="select-time-zone">
                    <div class="mb-4">
                        <label for="slotTimezone">Select timezone</label>
                        <span class="p-float-label">
                            <p-dropdown styleClass="form-control p-0 w-100" [style]="{maxWidth:'280px'}"
                                [options]="timezoneOpts" [(ngModel)]="selectedTimeZone" name="slotTimezone"
                                optionLabel="ftimeZone" [filter]="true" filterBy="ftimeZone" filterPlaceHolder="Search"
                                [tooltip]="selectedTimeZone?.ftimeZone" (onChange)="convertDate()">
                            </p-dropdown>
                            
                        </span>
                    </div>
        
                   
                </div>

            </div>
         </div>
         <div class="book-slot-rgt">
            <img loading="lazy" src="{{homePathUrl + '/book-demo/slot-img.png'}}" alt="slot">

            <div>
        
                <!-- <div *ngIf="filteredTimeSlots.length == 0 && slotsLoader">
                    <h6> Checking slots on {{ selectedDate | date: "MMM dd, y" }}</h6>
                    <div class="d-items-center loaderDiv">
                        <i class="pi pi-spin pi-spinner"></i>
                    </div>
                </div> -->

                <div *ngIf="filteredTimeSlots.length == 0 && !slotsLoader" class="select-date">        
                    <p>Please select another date</p>
                    <h6 class="mb-0">
                        No slots are available on {{ selectedDate | date: "MMM dd, y" }},
                    </h6>
                </div>

                <div *ngIf="filteredTimeSlots.length != 0 && !slotsLoader" class="available-date">
                    <h6>Available slots on {{ selectedDate | date: "MMM dd, y" }}</h6>
                    <div class="slotOptsDiv">
                        <span class="slotOpt" (click)="onSelectedSlot(i)"
                            *ngFor="let slot of filteredTimeSlots;let i = index"
                            [ngClass]="{'selected': i == selectedSlot}">
                            {{slot.startTime | date: "h:mm a"}} - {{slot.endTime| date: "h:mm a"}}
                        </span>
                    </div>
                </div>
            </div>

            <div class="buttons-div d-flex bottom-space justify-content-center text-center" *ngIf="showButtons">
                <button class="cancel-btn" *ngIf="showCancelButton" (click)="emitData(false)">
                    Cancel
                </button>
                <button class="save-btn"
                    [disabled]="!selectedDate || selectedTimeZone == null || selectedSlot == null  || loader"
                    (click)="emitData(true)">
                    <i class="pi pi-spin pi-spinner" *ngIf="loader"></i>
                    <span *ngIf="!loader">{{saveButtonText}}</span>
                </button>
            </div>
         </div>
    </div>

   
   

</div>
</div>